export default __webpack_public_path__ + "static/media/emissaryofelysium.733f17a7.png";